import { FormComponent } from 'ic-snacks' // eslint-disable-line

export type FormComponentType = React.Component<typeof FormComponent>

export interface ServerErrorType {
  paramErrors: { [key: string]: string }
  otherErrors: string
}
